(() => {
  'use strict';
  function initialize(root) {
  if (root.dataset.eteInitialized) return;
  root.dataset.eteInitialized = 'true';
  const config = JSON.parse(root.querySelector('[data-ete-config]').textContent);
  const uid = root.id;
  const copy = key => Array.isArray(config.messages[key]) ? config.messages[key].join('') : config.messages[key] ?? '';
  const interpolate = (key, values) => copy(key).replace(/\[\[(\d+)\]\]/g, (_, index) => String(values[Number(index)] ?? ''));
  const funnel = key => config.funnel?.[key] ?? '';
  const barriers = ['time', 'technical', 'budget'];

  const localSelector = selector => selector.replace(/#([a-zA-Z0-9_-]+)/g, '[data-ete-id="$1"]');
  const $ = (selector, scope = root) => scope.querySelector(localSelector(selector));
  const $$ = (selector, scope = root) => [...scope.querySelectorAll(localSelector(selector))];
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const money = value => '$' + Number(value).toLocaleString('en-US');
  const freshAnswers = () => ({barrier:'', etsy:'yes', mostSales:'not_asked', shopUrl:'', brandName:'', website:'', fit:'not_asked', goal:'build', otherGoal:'', name:'', email:'', phone:'', emailConsent:false, skipAddresses:true, sameShipping:true, billing:{}, shipping:{}});
  let answers = freshAnswers();
  let currentStep = 'barrier';
  let completedAt = '';
  let profileQueue = Promise.resolve();
  let profileSaveTimer;
  let profileRevision = 0;
  let runId = 0;
  let extrasState = 'idle';
  const analyticsSent = new Set();
  const selectedPackage = 'build';
  let addons = {meta:false, email:false, google:false};
  let maintenance = false;
  let leadState = 'idle';
  let marketingState = 'not_requested';
  let inquirySent = false;
  let busy = false;
  let cartAdded = false;
  const captureReady = Boolean(config.enableLeadCapture && /^[A-Za-z0-9]{6}$/.test(config.companyId || '') && !config.designMode);
  const subscriptionReady = Boolean(captureReady && config.listId);
  const checkoutConfigured = Boolean(config.enableCheckout && !config.designMode);

  const packages = {
    build: {name:copy('copy_091'), monthly:0}
  };

  const services = [
    {key:'meta', name:copy('copy_169'), description:copy('copy_170'), monthly:500},
    {key:'email', name:copy('copy_171'), description:copy('copy_172'), monthly:500},
    {key:'google', name:copy('copy_167'), description:copy('copy_168'), monthly:500}
  ];
  const selectedServices = () => services.filter(service => addons[service.key]);
  const marketingMonthly = () => selectedServices().reduce((total, service) => total + service.monthly, 0);
  const monthlyTotal = () => marketingMonthly() + (maintenance ? 169 : 0);

  function getSteps() {
    return ['barrier', 'store', 'contact'];
  }

  function track(name, step = '') {
    const key = `${name}:${step}`;
    if (config.designMode || analyticsSent.has(key)) return;
    const shopify = window.Shopify;
    try {
      if (!shopify?.customerPrivacy?.analyticsProcessingAllowed() || typeof shopify.analytics?.publish !== 'function') return;
      analyticsSent.add(key);
      const published = shopify.analytics.publish(`ete:${name}`, {funnel_version:'3-question-v1', ...(step ? {step} : {})});
      if (published && typeof published.catch === 'function') published.catch(() => {});
    } catch (_) {}
  }

  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {}); } catch (_) {}
  }

  function field(name, label, options = {}) {
    const {type = 'text', value = answers[name] || '', placeholder = '', autocomplete = '', required = false, full = false} = options;
    return `<div class="field${full ? ' field-full' : ''}"><label for="${uid}-${name}">${label}${required ? '' : copy('copy_109')}</label><input id="${uid}-${name}" data-ete-id="${name}" name="${name}" type="${type}" value="${escape(value)}"${placeholder ? ` placeholder="${escape(placeholder)}"` : ''}${autocomplete ? ` autocomplete="${autocomplete}"` : ''}${required ? ' required' : ''}></div>`;
  }

  const stepInfo = {
    barrier: [funnel('barrier_label'), funnel('barrier_title'), funnel('barrier_description')],
    store: [funnel('shop_label'), funnel('shop_title'), funnel('shop_description')],
    contact: [funnel('contact_label'), funnel('contact_title'), funnel('contact_description')],
    packages: [funnel('result_label'), funnel('result_title'), funnel('result_complete')],
    review: [copy('copy_143'), copy('copy_149'), copy('copy_150')]
  };

  function renderStep(focus = false) {
    const steps = getSteps();
    if (![...steps, 'packages', 'review'].includes(currentStep)) currentStep = 'barrier';
    const index = Math.max(0, steps.includes(currentStep) ? steps.indexOf(currentStep) : steps.length - 1);
    const info = [...stepInfo[currentStep]];
    if (currentStep === 'store' && answers.etsy === 'no') {
      info[1] = copy('copy_146');
      info[2] = copy('copy_147');
    }
    $('#step-label').textContent = info[0];
    $('#step-count').textContent = `${String(index + 1).padStart(2, '0')} / ${String(steps.length).padStart(2, '0')}`;
    const progress = Math.round(((index + 1) / steps.length) * 100);
    $('#progress-fill').style.width = `${progress}%`;
    $('.progress-track').setAttribute('aria-valuenow', String(progress));
    $('.progress-track').setAttribute('aria-valuetext', interpolate('copy_151', [index + 1,steps.length]));
    let fields = '';
    if (currentStep === 'barrier') fields = `<div class="barrier-options" role="group" aria-labelledby="${uid}-step-title">${barriers.map(key => `<button type="button" class="barrier-option${answers.barrier === key ? ' is-selected' : ''}" data-action="choose-barrier" data-barrier="${key}" aria-pressed="${answers.barrier === key}">${escape(funnel(`barrier_${key}`))}<span aria-hidden="true">→</span></button>`).join('')}</div>`;
    if (currentStep === 'store') {
      const storeFields = answers.etsy === 'yes' ? interpolate('copy_159', [field('shopUrl', funnel('shop_label'), {required:true, full:true, placeholder:funnel('shop_placeholder')})]) : `<div class="field-grid">${field('brandName', copy('copy_160'), {required:true, full:true, autocomplete:'organization', placeholder:copy('copy_161')})}${field('website', copy('copy_162'), {type:'url', full:true, placeholder:'https://yourbrand.com'})}</div>`;
      fields = interpolate('copy_173', [storeFields,answers.etsy === 'no' ? ' checked' : '']);
    }
    if (currentStep === 'contact') fields = interpolate('copy_178', [field('name', copy('copy_174'), {required:true, full:true, autocomplete:'name', placeholder:copy('copy_175')}),field('email', copy('copy_176'), {type:'email', required:true, full:true, autocomplete:'email', placeholder:'you@yourbrand.com'}),field('phone', copy('copy_177'), {type:'tel', full:true, autocomplete:'tel', placeholder:'+1 (555) 000-0000'}),answers.emailConsent ? ' checked' : '']);
    const terminal = ['packages', 'review'].includes(currentStep);
    const nextLabel = currentStep === 'contact' ? funnel('contact_continue') : copy('copy_185');
    $('#step-content').innerHTML = interpolate('copy_194', [interpolate('copy_187', [String(index + 1).padStart(2, '0')]),uid,info[1],info[2],terminal ? '' : `<form id="${uid}-quiz-form" data-ete-id="quiz-form" novalidate aria-labelledby="${uid}-step-title">${fields}<div id="${uid}-form-error" data-ete-id="form-error" class="form-error" role="alert" hidden></div><div class="step-actions">${index > 0 ? copy('copy_192') : ''}${currentStep === 'barrier' ? '' : `<button class="button button-dark" type="submit">${nextLabel} <span aria-hidden="true">→</span></button>`}</div></form>`]);
    $('.quiz-section').hidden = terminal;
    $('#packages').hidden = currentStep !== 'packages';
    $('#review').hidden = currentStep !== 'review';
    if (currentStep === 'packages') renderPackages();
    if (currentStep === 'contact') configureContact();
    if (currentStep === 'review') renderSummary();
    if (focus && !terminal) $('#step-title').focus({preventScroll:true});
  }

  function captureForm() {
    const previousInquiryData = JSON.stringify(answers);
    const form = $('#quiz-form');
    if (!form) return;
    const data = new FormData(form);
    const ordinary = ['barrier', 'etsy', 'mostSales', 'shopUrl', 'brandName', 'website', 'fit', 'goal', 'otherGoal', 'name', 'email', 'phone'];
    ordinary.forEach(key => { if (data.has(key)) answers[key] = String(data.get(key)).trim(); });
    if (currentStep === 'contact') answers.emailConsent = data.has('emailConsent');
    if (JSON.stringify(answers) !== previousInquiryData) {
      inquirySent = false;
      leadState = 'idle';
      marketingState = answers.emailConsent && subscribedEmail === answers.email ? 'accepted' : 'not_requested';
    }
  }

  function normalizeUrl(value) {
    return new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
  }

  function normalizeEtsyShop(value) {
    const input = value.trim();
    if (/^[A-Za-z0-9][A-Za-z0-9_-]{1,63}$/.test(input)) return `https://www.etsy.com/shop/${input}`;
    const url = normalizeUrl(input);
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.port) throw new Error();
    const hostname = url.hostname.toLowerCase();
    const path = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?shop\/([A-Za-z0-9][A-Za-z0-9_-]{1,63})\/?$/i);
    if (['etsy.com', 'www.etsy.com'].includes(hostname) && path) return `https://www.etsy.com/shop/${path[1]}`;
    const subdomain = hostname.match(/^([a-z0-9][a-z0-9-]{1,63})\.etsy\.com$/);
    if (subdomain && !['www', 'help', 'community', 'api', 'developers'].includes(subdomain[1]) && url.pathname === '/') return `https://www.etsy.com/shop/${subdomain[1]}`;
    throw new Error();
  }

  function error(message, name) {
    const box = $('#form-error');
    box.hidden = false;
    box.textContent = message;
    const control = $('#quiz-form').elements.namedItem(name);
    const element = control instanceof RadioNodeList ? control[0] : control;
    if (element) {
      element.setAttribute('aria-invalid', 'true');
      element.setAttribute('aria-describedby', `${uid}-form-error`);
      element.focus();
    }
    return false;
  }

  function validateStep() {
    const form = $('#quiz-form');
    $$('[aria-invalid]', form).forEach(control => { control.removeAttribute('aria-invalid'); control.removeAttribute('aria-describedby'); });
    $('#form-error').hidden = true;
    if (currentStep === 'barrier' && !barriers.includes(answers.barrier)) return error(funnel('barrier_error'), 'barrier');
    if (currentStep === 'store') {
      if (answers.etsy === 'yes') {
        try { answers.shopUrl = normalizeEtsyShop(answers.shopUrl); }
        catch (_) { return error(funnel('shop_error'), 'shopUrl'); }
      } else {
        if (!answers.brandName) return error(copy('copy_197'), 'brandName');
        if (answers.website) {
          try {
            const url = normalizeUrl(answers.website);
            if (!['http:', 'https:'].includes(url.protocol) || !url.hostname.includes('.') || url.username || url.password) throw new Error();
            answers.website = url.href;
          } catch (_) { return error(copy('copy_198'), 'website'); }
        }
      }
    }
    if (currentStep === 'contact') {
      if (!answers.name) return error(copy('copy_200'), 'name');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(answers.email)) return error(copy('copy_201'), 'email');
    }
    return true;
  }

  function goTo(step) {
    currentStep = step;
    if (step === 'packages') { track('quiz_completed'); track('offer_viewed'); }
    if (getSteps().includes(step)) track('quiz_step_viewed', step);
    if (step === 'review') track('review_viewed');
    renderStep(true);
    const target = step === 'packages' ? $('#packages') : step === 'review' ? $('#review') : $('#quiz-card');
    target.scrollIntoView({behavior:'smooth', block:'start'});
    if (step === 'review') $('#review-title').focus({preventScroll:true});
    if (step === 'packages') $('#packages-title').focus({preventScroll:true});
    $('#live-announcement').textContent = `${stepInfo[step][0]}. ${$('#step-title').textContent}`;
  }

  function renderPackages() {
    const expanded = Boolean($('#packages .optional-extras')?.open);
    const monthly = monthlyTotal();
    const addon = (name, title, description, price, checked) => interpolate('copy_211', [checked ? ' is-selected' : '',uid,name,checked ? ' checked' : '',title,description,price]);
    const optionalRows = services.map(service => addon(`${service.key}Addon`, service.name, service.description, money(service.monthly), addons[service.key])).join('') + addon('maintenance', copy('copy_308'), copy('copy_227'), '$169', maintenance);
    $('#packages').innerHTML = interpolate('copy_213', [escape(answers.name.split(' ')[0]),uid,optionalRows,money(monthly),escape(funnel(`result_${answers.barrier}`)),escape(funnel('result_complete'))]);
    insertPackagePortfolio();
    insertPaymentTerms($('#packages'), 'build');
    if (expanded && $('#packages .optional-extras')) $('#packages .optional-extras').open = true;
    renderResultStatus();
  }

  function insertPaymentTerms(container, location) {
    const template = root.querySelector('[data-ete-payment-terms-template]');
    const anchor = container.querySelector('[data-ete-payment-terms]');
    if (!template || !anchor) return;
    const fragment = template.content.cloneNode(true);
    [...fragment.querySelectorAll('form')].forEach((form, index) => {
      const previousId = form.getAttribute('id');
      const nextId = `${uid}-payment-terms-${location}-${index}`;
      form.setAttribute('id', nextId);
      [...fragment.querySelectorAll('[form]')].forEach(control => {
        if (control.getAttribute('form') === previousId) control.setAttribute('form', nextId);
      });
    });
    anchor.replaceWith(fragment);
  }

  function insertPackagePortfolio() {
    const template = root.querySelector('[data-ete-portfolio-template]');
    const anchor = $('#packages [data-ete-package-portfolio]');
    if (!template || !anchor) return;
    const fragment = template.content.cloneNode(true);
    [...fragment.querySelectorAll('.portfolio-card')].forEach((card, index) => {
      if (index > 2) card.remove();
      else card.removeAttribute('data-shopify-editor-block');
    });
    anchor.replaceWith(fragment);
  }

  function detailsRow(title, value, wide = false) {
    return `<div${wide ? ' class="wide"' : ''}><dt>${title}</dt><dd>${value}</dd></div>`;
  }

  function renderSummary() {
    const monthly = monthlyTotal();
    let detailRows = detailsRow(copy('copy_215'), `${escape(answers.name)}<br>${escape(answers.email)}${answers.phone ? `<br>${escape(answers.phone)}` : ''}`);
    detailRows += detailsRow(copy('copy_217'), answers.etsy === 'yes' ? `<a href="${escape(answers.shopUrl)}" target="_blank" rel="noopener noreferrer">${escape(answers.shopUrl)}</a>` : `${escape(answers.brandName)}${answers.website ? `<br><a href="${escape(answers.website)}" target="_blank" rel="noopener noreferrer">${escape(answers.website)}</a>` : ''}`);
    const chosen = selectedServices().map(service => `${service.name} — ${money(service.monthly)}${copy('copy_249')}`);
    if (maintenance) chosen.push(`${copy('copy_308')} — $169${copy('copy_249')}`);
    const selectedAddons = chosen.length ? chosen.map(addon => `<li>${addon}</li>`).join('') : `<li>${copy('copy_093')}</li>`;
    $('#review').innerHTML = interpolate('copy_258', [uid,money(monthly),selectedAddons,detailRows]);
    insertPaymentTerms($('#review'), 'review');
    renderConnection(false);
  }

  function renderResultStatus() {
    const holder = $('#packages [data-ete-result-status]');
    if (!holder) return;
    holder.textContent = `${extrasState === 'pending' ? funnel('lead_saving') : extrasState === 'failed' ? funnel('extras_failed') : connectionMessage()} ${marketingMessage()}`;
    if (extrasState === 'failed') {
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'text-button';
      retry.dataset.action = 'retry-selections';
      retry.textContent = copy('copy_275');
      holder.append(retry);
    }
  }

  function getVariant() {
    return (config.variants || []).find(variant => String(variant.title).toLowerCase().includes('foundation') && Number(variant.price) === 100000 && variant.available && !variant.requiresShipping);
  }

  function canCheckout() {
    return Boolean(checkoutConfigured && config.currency === 'USD' && getVariant());
  }

  function connectionMessage() {
    if (leadState === 'accepted') return funnel('lead_saved');
    if (leadState === 'partial') return copy('copy_260');
    if (leadState === 'failed') return funnel('lead_failed');
    return captureReady ? copy('copy_262') : copy('copy_263');
  }

  function marketingMessage() {
    if (!answers.emailConsent) return copy('copy_235');
    if (marketingState === 'accepted') return funnel('marketing_saved');
    if (marketingState === 'failed') return funnel('marketing_failed');
    if (marketingState === 'pending') return funnel('marketing_pending');
    if (!subscriptionReady) return copy('copy_266');
    return copy('copy_267');
  }

  function configureContact() {
    const footnote = document.createElement('p');
    footnote.className = 'step-footnote';
    footnote.textContent = funnel('contact_footnote');
    $('#quiz-form').append(footnote);
    const submit = $('#quiz-form button[type="submit"]');
    if (submit) submit.innerHTML = `${escape(funnel('contact_continue'))} <span aria-hidden="true">→</span>`;
    if (config.privacyUrl) {
      const paragraph = document.createElement('p');
      paragraph.className = 'privacy-note';
      const link = document.createElement('a');
      link.href = config.privacyUrl;
      link.textContent = copy('copy_272');
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      paragraph.append(link);
      $('#quiz-form').append(paragraph);
    }
  }

  const disabledControls = new WeakMap();
  function setBusy(value) {
    busy = value;
    root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('button, input, textarea, select').forEach(control => {
      if (value) { disabledControls.set(control, control.disabled); control.disabled = true; }
      else {
        control.disabled = Boolean(disabledControls.get(control)) || (control.dataset.action === 'checkout' && !canCheckout()) || (control.dataset.action === 'send-inquiry' && (!captureReady || inquirySent));
        disabledControls.delete(control);
      }
    });
  }

  function showContactStatus(message, failed = false, actions = false) {
    let panel = $('[data-ete-contact-status]');
    if (!panel) {
      panel = document.createElement('div');
      panel.dataset.eteContactStatus = '';
      panel.setAttribute('role', failed ? 'alert' : 'status');
      $('#quiz-form').append(panel);
    }
    panel.setAttribute('role', failed ? 'alert' : 'status');
    panel.className = `integration-status${failed ? " is-error" : ''}`;
    panel.textContent = message;
    if (actions) {
      const controls = document.createElement('div');
      controls.className = 'integration-actions';
      for (const [action, label] of [['retry-lead',copy('copy_275')], ['continue-unsaved',leadState === 'partial' ? copy('copy_276') : copy('copy_277')]]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'text-button';
        button.dataset.action = action;
        button.textContent = label;
        controls.append(button);
      }
      panel.append(controls);
    }
  }

  async function postKlaviyo(path, payload) {
    if (!captureReady) throw new Error(copy('copy_278'));
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(`https://a.klaviyo.com/client/${path}?company_id=${encodeURIComponent(config.companyId)}`, {
        method:'POST', mode:'cors', credentials:'omit', signal:controller.signal,
        headers:{'Content-Type':'application/vnd.api+json', Accept:'application/vnd.api+json', revision:'2026-07-15'},
        body:JSON.stringify(payload)
      });
      if (!response.ok) throw new Error(copy('copy_279'));
    } finally { window.clearTimeout(timeout); }
  }

  let subscribedEmail = '';
  function saveProfile(inquiry = false, stage = 'plan_viewed') {
    if (!captureReady) return Promise.resolve(false);
    const revision = ++profileRevision;
    const generation = runId;
    const names = answers.name.trim().split(/\s+/);
    const attributes = {
      email:answers.email,
      first_name:names.shift() || '',
      last_name:names.join(' '),
      properties:{
        ete_source:copy('copy_280'),
        ete_quiz_version:'3-question-v1',
        ete_quiz_stage:completedAt ? 'completed' : 'started',
        ete_quiz_completed:Boolean(completedAt),
        ete_quiz_completed_at:completedAt,
        ete_primary_barrier:answers.barrier,
        ete_offer_stage:stage,
        ete_has_etsy_shop:answers.etsy,
        ete_most_sales_etsy:answers.etsy === 'yes' ? 'not_asked' : 'not_applicable',
        ete_etsy_shop_url:answers.etsy === 'yes' ? answers.shopUrl : '',
        ete_brand_name:answers.brandName,
        ete_website:answers.website,
        ete_contact_phone:answers.phone,
        ete_fit:answers.fit,
        ete_goal:answers.goal,
        ete_other_goal:answers.otherGoal,
        ete_selected_package:inquiry ? 'inquiry' : packages[selectedPackage].name,
        ete_setup_usd:inquiry ? 0 : 1000,
        ete_selected_addons:inquiry ? [] : selectedServices().map(service => service.name),
        ete_meta_ads_selected:inquiry ? false : addons.meta,
        ete_email_blasts_selected:inquiry ? false : addons.email,
        ete_google_ads_selected:inquiry ? false : addons.google,
        ete_addon_meta_monthly_usd:inquiry || !addons.meta ? 0 : 500,
        ete_addon_email_monthly_usd:inquiry || !addons.email ? 0 : 500,
        ete_addon_google_monthly_usd:inquiry || !addons.google ? 0 : 500,
        ete_monthly_services_usd:inquiry ? 0 : marketingMonthly(),
        ete_maintenance_selected:inquiry ? false : maintenance,
        ete_maintenance_monthly_usd:inquiry || !maintenance ? 0 : 169,
        ete_monthly_total_usd:inquiry ? 0 : monthlyTotal(),
        ete_monthly_activation:copy('copy_281'),
        ete_ad_budget:copy('copy_282'),
        ete_email_marketing_requested:answers.emailConsent,
        ete_request_type:inquiry ? 'inquiry' : 'store_setup'
      }
    };
    const execute = async () => {
      if (generation !== runId) return false;
      try {
        await postKlaviyo('profiles', {data:{type:'profile', attributes}});
        if (generation === runId && revision === profileRevision) {
          leadState = 'accepted';
          extrasState = 'saved';
          renderResultStatus();
          if (currentStep === 'review' && !busy) renderConnection(false);
        }
        if (generation === runId) track('lead_captured');
        requestMarketing(attributes.email, attributes.properties.ete_email_marketing_requested, generation);
        return true;
      } catch (_) {
        if (generation === runId && revision === profileRevision) {
          leadState = 'failed';
          extrasState = 'failed';
          renderResultStatus();
          if (currentStep === 'review' && !busy) renderConnection(false);
        }
        return false;
      }
    };
    const pending = profileQueue.then(execute, execute);
    profileQueue = pending;
    return pending;
  }

  const marketingAttempts = new Set();
  function requestMarketing(email, consent, generation) {
    if (!consent || generation !== runId || marketingAttempts.has(email)) return;
    if (!subscriptionReady) { marketingState = 'failed'; renderResultStatus(); return; }
    marketingAttempts.add(email);
    marketingState = 'pending';
    postKlaviyo('subscriptions', {data:{type:'subscription', attributes:{custom_source:copy('copy_283'), profile:{data:{type:'profile', attributes:{email, subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}}, relationships:{list:{data:{type:'list',id:config.listId}}}}})
      .then(() => { subscribedEmail = email; if (generation === runId && answers.email === email) marketingState = 'accepted'; })
      .catch(() => { if (generation === runId && answers.email === email) marketingState = 'failed'; })
      .finally(() => { if (generation === runId) { renderResultStatus(); if (currentStep === 'review' && !busy) renderConnection(false); } });
  }

  function saveSelections(stage = 'extras_selected', immediately = false) {
    window.clearTimeout(profileSaveTimer);
    if (!completedAt || !captureReady) return Promise.resolve(false);
    profileRevision += 1;
    extrasState = 'pending';
    renderResultStatus();
    if (immediately) return saveProfile(false, stage);
    profileSaveTimer = window.setTimeout(() => { saveProfile(false, stage); }, 400);
    return Promise.resolve(true);
  }

  async function saveContactBeforeContinue() {
    setBusy(true);
    showContactStatus(funnel('lead_saving'));
    completedAt ||= new Date().toISOString();
    try {
      const succeeded = await saveProfile(false);
      if (!succeeded) showContactStatus(connectionMessage(), true, true);
      return succeeded;
    } finally { setBusy(false); }
  }

  function advanceContact() {
    if (currentStep !== 'contact' || busy) return;
    goTo('packages');
  }

  async function retryContact() {
    if (busy || currentStep !== 'contact') return;
    captureForm();
    if (!validateStep()) return;
    if (await saveContactBeforeContinue()) advanceContact();
  }

  function renderConnection(reviewOnly) {
    const holder = $('[data-ete-checkout]');
    if (!holder) return;
    const enabled = reviewOnly ? captureReady && !inquirySent : canCheckout();
    const label = reviewOnly ? inquirySent ? copy('copy_285') : captureReady ? copy('copy_286') : copy('copy_287') : enabled ? copy('copy_288') : copy('copy_289');
    const explanation = reviewOnly ? inquirySent ? copy('copy_290') : captureReady ? copy('copy_291') : copy('copy_292') : enabled ? copy('copy_293') : copy('copy_294');
    holder.innerHTML = `<div class="checkout-note"><p><strong>${reviewOnly ? copy('copy_295') : copy('copy_296')}</strong>${escape(explanation)}</p><button class="button" type="button" data-action="${reviewOnly ? 'send-inquiry' : 'checkout'}"${enabled ? '' : ' disabled'}>${escape(label)}</button></div><div class="integration-status" data-ete-final-status role="status">${escape(connectionMessage())}<br>${escape(marketingMessage())}</div>`;
  }

  function finalStatus(message, failed = false, checkoutFallback = false) {
    const panel = $('[data-ete-final-status]');
    if (!panel) return;
    panel.setAttribute('role', failed ? 'alert' : 'status');
    panel.className = `integration-status${failed ? " is-error" : ''}`;
    panel.textContent = message;
    if (checkoutFallback) {
      const controls = document.createElement('div');
      controls.className = 'integration-actions';
      for (const [action,label] of [['checkout',copy('copy_297')], ['checkout-unsaved',copy('copy_298')]]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'text-button';
        button.dataset.action = action;
        button.textContent = label;
        controls.append(button);
      }
      panel.append(controls);
    }
  }

  async function sendInquiry() {
    if (busy || !captureReady || inquirySent) return;
    setBusy(true);
    finalStatus(copy('copy_299'));
    try {
      const succeeded = await saveProfile(true);
      if (succeeded) inquirySent = true;
      renderConnection(true);
      if (!succeeded) finalStatus(connectionMessage() + ' ' + marketingMessage(), true);
    } finally { setBusy(false); }
  }

  async function cartRequest(path, body) {
    const response = await fetch(`${config.rootUrl || '/'}${path}`, {method:body ? 'POST' : 'GET', credentials:'same-origin', headers:{Accept:'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || copy('copy_300'));
    return data;
  }

  async function beginCheckout(skipLeadUpdate = false) {
    if (busy || !canCheckout()) return;
    setBusy(true);
    finalStatus(copy('copy_301'));
    try {
      if (captureReady && !skipLeadUpdate) {
        const updated = await saveSelections('checkout_requested', true);
        if (!updated) { finalStatus(connectionMessage() + copy('copy_302'), true, true); return; }
      }
      const variant = getVariant();
      const item = packages[selectedPackage];
      const properties = {
        '_ete_quiz':'etsy_growth_setup',
        [`_${copy('copy_303')}`]:item.name,
        [`_${copy('copy_304')}`]:answers.etsy === 'yes' ? answers.shopUrl : copy('copy_305'),
        [copy('copy_217')]:answers.etsy === 'yes' ? answers.shopUrl : [answers.brandName, answers.website].filter(Boolean).join(' · '),
        [`_${copy('copy_306')}`]:answers.goal,
        [`_${copy('copy_307')}`]:selectedServices().map(service => `${service.name}: ${money(service.monthly)}/month after approval`).join('; ') || copy('copy_093'),
        '_ete_selected_addons':selectedServices().map(service => service.key).join(',') || 'none',
        ...Object.fromEntries(selectedServices().map(service => [service.name,`${money(service.monthly)}/month after approval`])),
        [`_${copy('copy_308')}`]:maintenance ? copy('copy_309') : copy('copy_310'),
        ...(maintenance ? {[copy('copy_308')]:`${money(169)}/month after approval`} : {}),
        [copy('copy_311')]:`${money(monthlyTotal())}/month after approval`,
        [`_${copy('copy_312')}`]:copy('copy_313'),
        [`_${copy('copy_229')}`]:addons.meta || addons.google ? copy('copy_315') : copy('copy_314')
      };
      const existing = await cartRequest('cart.js');
      const oldLines = (existing.items || []).filter(line => line.properties && line.properties._ete_quiz === 'etsy_growth_setup');
      const matching = oldLines.find(line => Number(line.variant_id) === Number(variant.id));
      if (matching) await cartRequest('cart/change.js', {id:matching.key,quantity:1,properties});
      else await cartRequest('cart/add.js', {items:[{id:variant.id,quantity:1,properties}]});
      const duplicateKeys = oldLines.filter(line => !matching || line.key !== matching.key).map(line => line.key);
      if (duplicateKeys.length) await cartRequest('cart/update.js', {updates:Object.fromEntries(duplicateKeys.map(lineKey => [lineKey,0]))});
      cartAdded = true;
      finalStatus(copy('copy_316'));
      track('checkout_started');
      window.location.assign(`${config.rootUrl || '/'}checkout`);
    } catch (_) {
      finalStatus(copy('copy_317'), true);
      const panel = $('[data-ete-final-status]');
      const link = document.createElement('a');
      link.href = `${config.rootUrl || '/'}cart`;
      link.textContent = copy('copy_318');
      link.className = 'text-button';
      panel.append(document.createElement('br'),link);
    } finally { setBusy(false); }
  }

  root.addEventListener('submit', async event => {
    if (event.target.dataset.eteId !== 'quiz-form') return;
    event.preventDefault();
    captureForm();
    if (!validateStep() || busy) return;
    track('quiz_step_completed', currentStep);
    if (currentStep === 'contact') {
      completedAt ||= new Date().toISOString();
      if (captureReady && !await saveContactBeforeContinue()) return;
      goTo('packages');
      return;
    }
    const steps = getSteps();
    goTo(steps[steps.indexOf(currentStep) + 1]);
  });

  root.addEventListener('change', event => {
    if (busy) return;
    if (event.target.name === 'noEtsy') {
      captureForm();
      answers.etsy = event.target.checked ? 'no' : 'yes';
      renderStep();
      $('[name="noEtsy"]').focus({preventScroll:true});
    }
    if (['metaAddon', 'emailAddon', 'googleAddon', 'maintenance'].includes(event.target.name)) {
      const name = event.target.name;
      if (name === 'maintenance') maintenance = event.target.checked;
      else addons[name.replace('Addon', '')] = event.target.checked;
      answers.goal = selectedServices().map(service => service.key).join(', ') || 'build';
      saveSelections();
      renderPackages();
      $(`[name="${name}"]`)?.focus({preventScroll:true});
      $('#live-announcement').textContent = interpolate('copy_319', [money(monthlyTotal())]);
    }
  });

  root.addEventListener('click', event => {
    const quizLink = event.target.closest('a[href]');
    if (!busy && quizLink?.getAttribute('href') === `#${uid}-quiz`) {
      event.preventDefault();
      captureForm();
      track('quiz_started');
      goTo(getSteps().includes(currentStep) ? currentStep : 'packages');
      return;
    }
    const trigger = event.target.closest('[data-action]');
    if (!trigger) return;
    const action = trigger.dataset.action;
    if (busy) return;
    if (action === 'choose-barrier' && barriers.includes(trigger.dataset.barrier)) {
      answers.barrier = trigger.dataset.barrier;
      track('quiz_started');
      track('quiz_step_viewed', 'barrier');
      track('quiz_step_completed', 'barrier');
      goTo('store');
    }
    if (action === 'back') {
      captureForm();
      const steps = getSteps();
      const index = steps.indexOf(currentStep);
      if (index > 0) goTo(steps[index - 1]);
    }
    if (action === 'edit-answers') goTo('barrier');
    if (action === 'edit-package') goTo('packages');
    if (action === 'review-package') { saveSelections('reviewed', true); goTo('review'); }
    if (action === 'restart') {
      window.clearTimeout(profileSaveTimer);
      runId += 1;
      completedAt = '';
      extrasState = 'idle';
      analyticsSent.clear();
      answers = freshAnswers();
      addons = {meta:false, email:false, google:false};
      maintenance = false;
      leadState = 'idle';
      marketingState = 'not_requested';
      inquirySent = false;
      cartAdded = false;
      $('#packages').innerHTML = '';
      $('#review').innerHTML = '';
      goTo('barrier');
    }
    if (action === 'retry-selections') saveSelections('plan_viewed', true);
    if (action === 'retry-lead') retryContact();
    if (action === 'continue-unsaved') advanceContact();
    if (action === 'checkout') beginCheckout(false);
    if (action === 'checkout-unsaved') beginCheckout(true);
    if (action === 'send-inquiry') sendInquiry();
    if (action === 'print') window.print();
  });

  renderStep();
  }
  document.querySelectorAll('[data-ete-quiz]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ete-quiz]').forEach(initialize));
})();
